import { isEqual, sortBy } from "es-toolkit";
import { differenceWith, flattenDeep } from "lodash-es";

export function swapItems(array: any[], index1: number, index2: number): void {
  [array[index1], array[index2]] = [array[index2], array[index1]];
}

export function flattenTree(tree: any[], itemsFn: (item: any) => any[]): any[] {
  return flattenDeep([
    ...tree.map((x) => flattenTree(itemsFn(x), itemsFn)),
    ...tree
  ]);
}

export function difference<T>(
  source: Array<T>,
  destination: Array<T>,
  comparator: (a: T, b: T) => boolean
): { added: Array<T>; removed: Array<T> } {
  return {
    added: differenceWith(destination ?? [], source ?? [], comparator),
    removed: differenceWith(source ?? [], destination ?? [], comparator)
  };
}

export function arrayContainsSameItems(
  arrayA: unknown[],
  arrayB: unknown[]
): boolean {
  return isEqual(arrayA.sort(), arrayB.sort());
}
